import axios from "axios";

declare global {
  interface Window {
    env: any;
  }
}

const baseURL = process.env.REACT_APP_EDFAPAY /* process.env.REACT_APP_DISCOVER   *///process.env.REACT_APP_LOCAL_SERVER_BACKEND
const api = axios.create({
  baseURL,
});

const baseURLdev = process.env.REACT_APP_EDFAPAY  /* process.env.REACT_APP_DISCOVER  */  //"http://edfapay-develop.byte01.space/"; //"http://127.0.0.1:8080/";
export const apidev = axios.create({
  baseURL: baseURLdev,
});

const Attestationapi: any = axios.create({
  baseURL: process.env.REACT_APP_ATTESTATION,
});

const APKBuildServerUrlAPI: any = axios.create({
  baseURL: "http://8.213.31.168:8101" //process.env.REACT_APP_APK_BUILD_URL,
});

const SetupInterceptors = (http: any) => {
  http.interceptors.request.use(
    (config: any) => {
      return config;
    },
    (error: any) => {
      const status = error?.request?.status || 0;
      const resBaseURL = error?.request?.config?.baseURL;
      if (
        (resBaseURL === baseURL && status === 401) ||
        (resBaseURL === baseURLdev && status === 401)
      ) {
        if (localStorage.getItem("token")) {
          localStorage.clear();
          //window.location.assign('/login')
          return Promise.reject(error);
        } else {
          return Promise.reject(error);
        }
      }
      return Promise.reject(error);
    }
  );

  http.interceptors.response.use(
    function (response: any) {
      return response;
    },
    function (error: any) {
      const status = error?.response?.status || 0;
      const resBaseURL = error?.response?.config?.baseURL;
      if (
        (resBaseURL === baseURL && status === 401) ||
        (resBaseURL === baseURLdev && status === 401)
      ) {
        window.location.assign("/login");
        localStorage.setItem("tokExp", "1");
        return Promise.reject(error);
      } else if (
        (resBaseURL === baseURL && status === 500) ||

        (resBaseURL === baseURLdev && status === 500)
      ) {
        //window.location.assign('/login')
        localStorage.setItem("errRes", "1");
        return Promise.reject(error);
      }
      return Promise.reject(error);
    }
  );
};



SetupInterceptors(api);
SetupInterceptors(Attestationapi);
SetupInterceptors(apidev);


export default api;
export { Attestationapi };
export { APKBuildServerUrlAPI }